import { FlexColumn } from '@editor/components/utilities/layouts';
import styled from 'styled-components';

export const ProceedButtonWrapper = styled(FlexColumn)`
  margin-top: auto;
  gap: 12px;
  align-items: center;
`;
